import React, { useContext, useEffect,useState } from 'react';
import { getAdJobTicket } from '../services/apiService';
import { PageContext } from './PageContext';
import parse from 'html-react-parser';
import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { translateText } from '../services/apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faGoogle} from '@fortawesome/free-brands-svg-icons';


import languageList from "../languages.json";

export function JobTicket (){

    const pageContext=useContext(PageContext);
    const [ticketBody, setTicketBody]=useState("");
    const [activeLang, setActiveLang]= useState(pageContext?.glSettings.Locale);
    //console.log (pageContext?.selectedAd);
    const jobTicket=()=>{
        let tikText = getAdJobTicket(pageContext?.selectedAd.element, pageContext?.selectedAd.elementType, pageContext?.selectedAd.slug,pageContext?.selectedAd.file1)
            .then(ticket=>{
                if (ticket){
                    const parser=new DOMParser();
                    const doc = parser.parseFromString(ticket, "text/html");
                    const body = doc.querySelector("body")
                    //console.log(body?.innerHTML)
                    setTicketBody(body?.innerHTML||"");
                }
            });
    }


    const translate=()=>{

        translateText("en","de",ticketBody).then(translatedText=>{
            if (translatedText!="Translation Failed"){
                console.log(translatedText);
                setTicketBody(translatedText);   
            }
        });
    }

    const languageChange = (props:DropDownListChangeEvent): void => {
        console.log(props);
        console.log(props.target.value);
        const target = props.target.value.code;
        setActiveLang(target);
        translateText(activeLang,target,ticketBody).then(translatedText=>{
            if (translatedText!="Translation Failed"){
                console.log(translatedText);
                setTicketBody(translatedText);   
            }
        });
    }

    useEffect(() => {
        jobTicket();
    }, []);

    return (
        <div style={{marginBottom:20}}>
        <FontAwesomeIcon size="lg" style={{marginRight:10}} icon={faGoogle}></FontAwesomeIcon>
        <DropDownList
            data={languageList}
            textField='name'
            dataItemKey='code'
            onChange={languageChange}
            defaultItem={{name:"Translate with Google", value:""}}
            style={{width:200}}
        ></DropDownList>
        {parse(ticketBody)}
        </div>
    );

}
